import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  createCalenderSeprator, getCalenderSeprator, getCalenderSepratorById, updateCalenderSeprator,
} from '../../axios/eventsRequests';
import {
  uploadSingleImage,
} from '../../helperFunctions/uploadService';
import {
  ICalenderSeprator,
} from '../storeInterfaces/calenderSepratorInterface';
import {
  isImageArray,
} from '../storeInterfaces/featuredArticlesStore';
import { RequestStatus } from 'mobx-store';

export class CalenderSepratorStore {
  @observable calenderSepratorList: ICalenderSeprator[] = [];

  @observable selectedCalenderSeprator = {

  };

  @observable loading = false;

  @observable getCalendarSeperatorRequestStatus: RequestStatus = RequestStatus.IDLE; 

  @action
  public async getCalenderSeprator(): Promise<any> {
    try {
      this.loading = true;
      this.getCalendarSeperatorRequestStatus = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(getCalenderSeprator);
      this.calenderSepratorList = response.data;
      this.loading = false;
      this.getCalendarSeperatorRequestStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.getCalendarSeperatorRequestStatus = RequestStatus.FAILED;
      console.log(error);
      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action
  public async filterCalenderSeprator(query: string): Promise<void> {
    try {
      this.loading = true;
      const config = {
        params: {
          query,
        },
      };
      const response = await Connections.wadiDeglaAxios.httpGet(getCalenderSeprator, config);
      this.calenderSepratorList = response.data;
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async getCalenderSepratorById(id: number): Promise<void> {
    try {
      this.loading = true;
      const {
        data,
      } = await Connections.wadiDeglaAxios.httpGet(getCalenderSepratorById(id));
      let {
        imageURL, date, title,
      } = data;

      imageURL = imageURL ? [{
        imageUrl: imageURL,
      }] : [];
      date = date ? new Date(Number(date)) : null;

      this.selectedCalenderSeprator = {
        imageURL, date, title,
      };
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action.bound
  public async createCalenderSeprator(newCalenderSeprator: ICalenderSeprator): Promise<number> {
    try {
      if (isImageArray(newCalenderSeprator.imageURL)) {
        newCalenderSeprator.imageURL = await uploadSingleImage(newCalenderSeprator.imageURL);
      }
      newCalenderSeprator.date = new Date(newCalenderSeprator.date).getTime();
      const response = await Connections.wadiDeglaAxios.httpPost(createCalenderSeprator, newCalenderSeprator);
      return response.data.calenderSepratorId;
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    }
  }

  @action.bound
  public async updateCalenderSeprator(updatedCalenderSeprator: any, calenderSepratorId: number): Promise<void> {
    try {
      if (isImageArray(updatedCalenderSeprator.imageURL)) {
        updatedCalenderSeprator.imageURL = await uploadSingleImage(updatedCalenderSeprator.imageURL);
      }
      updatedCalenderSeprator.date = new Date(updatedCalenderSeprator.date).getTime();
      await Connections.wadiDeglaAxios.httpPut(updateCalenderSeprator(calenderSepratorId), updatedCalenderSeprator);
    } catch (error) {
      console.log(error);
      return Promise.reject(error);
    }
  }
}
